
Greenmile.UnsupportedBrowser = {

    isUnsupportedBrowser: true,

    check: function () {

        const browser = window.Bowser;

        if (( browser.chrome  && browser.version > 35 ) ||
            ( browser.safari  && browser.version > 4 )  ||
            ( browser.firefox && browser.version > 30 ) ||
            ( browser.msie    && browser.version > 9 )  ||
            ( browser.msedge )                          ||
            ( browser.opera   && browser.version > 10.50 )){

            Greenmile.UnsupportedBrowser.isUnsupportedBrowser = false;

        } else {

            Greenmile.UnsupportedBrowser.render();

        }

    },

    render: function () {

        var contentContainer = document.createElement('div');
        var greenmileLogo = document.createElement('div');
        var unsTextContainer = document.createElement('div');
        var chromeIcon = document.createElement('div');
        var firefoxIcon = document.createElement('div');
        var ieIcon = document.createElement('div');
        var chromeText = document.createElement('div');
        var firefoxText = document.createElement('div');
        var ieText = document.createElement('div');

        contentContainer.className = 'unsupportedBrowserContainer';
        greenmileLogo.className = 'greenmileLogo';
        unsTextContainer.className = 'unsupportedTextContainer';
        chromeIcon.className = 'chromeIcon';
        firefoxIcon.className = 'firefoxIcon';
        ieIcon.className = 'ieIcon';
        chromeText.className = 'chromeText';
        firefoxText.className = 'firefoxText';
        ieText.className = 'ieText';

        unsTextContainer.innerHTML = 'You are using an unsupported browser';
        chromeText.innerHTML = 'Chrome > 35 <span> Recomended </span>';
        firefoxText.innerHTML = 'Firefox > 30';
        ieText.innerHTML = 'IE 11+';

        contentContainer.appendChild(greenmileLogo);
        contentContainer.appendChild(unsTextContainer);
        contentContainer.appendChild(chromeIcon);
        contentContainer.appendChild(firefoxIcon);
        contentContainer.appendChild(ieIcon);
        contentContainer.appendChild(chromeText);
        contentContainer.appendChild(firefoxText);
        contentContainer.appendChild(ieText);

        document.body.appendChild(contentContainer);

    }
};
